import React, { useRef } from 'react';
var VeltNotificationsPanelContentDocumentsListItemCount = function (props) {
    var children = props.children;
    var ref = useRef(null);
    return (React.createElement("velt-notifications-panel-content-documents-list-item-count", { ref: ref }, children));
};
export default VeltNotificationsPanelContentDocumentsListItemCount;
